import { render, staticRenderFns } from "./EditFormSubTypeBlock.vue?vue&type=template&id=5c7f9d20&scoped=true&"
import script from "./EditFormSubTypeBlock.vue?vue&type=script&lang=js&"
export * from "./EditFormSubTypeBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f9d20",
  null
  
)

export default component.exports